/* eslint-disable */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import * as React from 'react';

/**
 * This hook is for creating a state which can either be controlled or uncontrolled.
 */
export default function useControlled({
  default: defaultValueProp,
  controlled: valueProp
}) {
  const { current: isControlled } = React.useRef(valueProp !== undefined);
  const [defaultValue, setDefaultValue] = React.useState(defaultValueProp);
  const value = isControlled ? valueProp : defaultValue;

  const setUncontrolledValue = React.useCallback((newValue) => {
    if (!isControlled) {
      setDefaultValue(newValue);
    }
  }, []);

  return [value, setUncontrolledValue];
}
